import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-zoomable-gallery-modal__nav _flexbtwn _ai-c _px-3 _py-3" }
const _hoisted_2 = { class: "_tc--gray" }
const _hoisted_3 = { class: "gfu-zoomable-gallery" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src", "data-qa"]
const _hoisted_6 = { class: "gfu-zoomable-gallery__controls _flexbtwn _ai-c _px-4" }
const _hoisted_7 = {
  key: 1,
  class: "_flex _jc-c _gap-1 _grow-1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_base_carousel = _resolveComponent("base-carousel")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "is-visible": true,
    "body-class-list": ['gfu-zoomable-gallery-modal'],
    "data-qa": "zoomable-gallery-modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString($options.galleryNavigationText), 1 /* TEXT */),
        _createElementVNode("a", {
          href: "#",
          class: "_flexaicntr _tc--accent _ml-a",
          onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onGalleryClose && $options.onGalleryClose(...args)), ["prevent"]))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Common.ModalCloseButton), 1 /* TEXT */),
          _createVNode(_component_base_icon, {
            name: "times",
            class: "modal-navigation__icon _ml-1 _fr",
            "data-qa": "modal-button:Close"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_progress_overlay, {
          visible: !$data.isMediaLoaded
        }, null, 8 /* PROPS */, ["visible"]),
        _createVNode(_component_base_carousel, {
          current: $data.currentDisplayedMedia,
          class: "gfu-zoomable-gallery__slider",
          "can-swipe": $options.canSwipe,
          onChange: $options.onChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedMedia, (medium, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: medium.mediaUrl + index,
                class: _normalizeClass(medium.slideClasses)
              }, [
                ($options.isTypeVideo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (medium.isActive)
                        ? (_openBlock(), _createElementBlock("video", {
                            key: 0,
                            controls: "",
                            autoplay: "",
                            preload: "metadata",
                            class: "gfu-zoomable-gallery__video",
                            src: medium.mediaUrl,
                            onLoadedmetadata: _cache[1] || (_cache[1] = (...args) => ($options.onMediaLoaded && $options.onMediaLoaded(...args))),
                            "data-qa": `zoomable-gallery-video${medium.isActive ? '-active' : ''}`
                          }, " Your browser does not support the video tag. ", 40 /* PROPS, NEED_HYDRATION */, _hoisted_5))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      ref_for: true,
                      ref: "imageContainer",
                      class: "gfu-zoomable-gallery__image _flexcntr _ai-c"
                    }, [
                      _createVNode(_component_base_image, {
                        ref_for: true,
                        ref: "image",
                        draggable: "false",
                        src: medium.mediaUrl,
                        class: _normalizeClass($options.imageClass),
                        onLoad: $options.onMediaLoaded,
                        "data-qa": `zoomable-gallery-image${medium.isActive ? '-active' : ''}`
                      }, null, 8 /* PROPS */, ["src", "class", "onLoad", "data-qa"])
                    ], 512 /* NEED_PATCH */))
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          controls: _withCtx(({ onNext, onPrev }) => [
            _createElementVNode("div", _hoisted_6, [
              ($options.hasMoreThanOneSlide)
                ? (_openBlock(), _createBlock(_component_base_carousel_navigation, {
                    key: 0,
                    class: "gfu-zoomable-gallery-nav-item",
                    type: "prev",
                    icon: "angle-left",
                    onClick: onPrev,
                    "data-qa": "previous-button"
                  }, null, 8 /* PROPS */, ["onClick"]))
                : _createCommentVNode("v-if", true),
              (!$options.isTypeVideo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_base_carousel_navigation, {
                      ref: "zoomOutButton",
                      class: "gfu-zoomable-gallery-nav-item",
                      icon: "minus",
                      "data-qa": "zoom-out-button"
                    }, null, 512 /* NEED_PATCH */),
                    _createVNode(_component_base_carousel_navigation, {
                      ref: "zoomInButton",
                      class: "gfu-zoomable-gallery-nav-item",
                      icon: "plus",
                      "data-qa": "zoom-in-button"
                    }, null, 512 /* NEED_PATCH */)
                  ]))
                : _createCommentVNode("v-if", true),
              ($options.hasMoreThanOneSlide)
                ? (_openBlock(), _createBlock(_component_base_carousel_navigation, {
                    key: 2,
                    class: "gfu-zoomable-gallery-nav-item",
                    type: "prev",
                    icon: "angle-right",
                    onClick: onNext,
                    "data-qa": "next-button"
                  }, null, 8 /* PROPS */, ["onClick"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["current", "can-swipe", "onChange"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}